import { LuStar } from "react-icons/lu";
import {
  AuthorContainer,
  AuthorDetails,
  Avatar,
  Card,
  Container,
  ContentContainer,
  Content,
  Description,
  Grid,
  Header,
  Section,
  Stars,
  Tag,
  Title
} from "./styles";

export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      content:
        "Sou Cirurgiã-Dentista e faço o uso do DentalMap para meu dia a dia no trabalho. O sistema é bem amplo, fornecendo agenda inteligente, odontograma, receituário, entre outros que são bastantes interessantes no nosso mercado de trabalho. Além de agilizar nossa vida e a do paciente. Estou gostando muito da experiência!",
      author: "Dra. Giovanna Moraes",
      role: "Dentista, Clinica Moraes e Reis",
      avatar: "/images/perfilgio.png",
      rating: 5
    },
    {
      id: 2,
      content:
        "A implementação do DentalMap foi extremamente simples e o suporte é excepcional. O sistema facilitou e ofereceu uma visão clara do consultório como um todo.",
      author: "Dr. Roberto Almeida",
      role: "Ortodontista, Clinica Sorriso",
      avatar: "https://randomuser.me/api/portraits/men/54.jpg",
      rating: 5
    },
    {
      id: 3,
      content:
        "Estou impressionada com a praticidade do prontuário eletrônico. Posso acessar o histórico completo dos pacientes em segundos, incluindo imagens e exames, o que melhorou significativamente a qualidade dos atendimentos.",
      author: "Dra. Patrícia Costa",
      role: "Odontopediatra, Clínica Infantil Dentinho",
      avatar: "https://randomuser.me/api/portraits/women/45.jpg",
      rating: 5
    }
  ];

  return (
    <Section id="depoimentos">
      <Container>
        <Header>
          <Tag>Depoimentos</Tag>
          <Title>O que nossos clientes dizem</Title>
          <Description>
            Veja como o DentalMap tem ajudado profissionais e clínicas
            odontológicas a melhorar seus processos e resultados.
          </Description>
        </Header>

        <Grid>
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id}>
              <Stars>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <LuStar key={i} size={20} color="#0C6ACB" fill="#0C6ACB" />
                ))}
              </Stars>
              <ContentContainer>
                <Content>&quot;{testimonial.content}&quot;</Content>
                <AuthorContainer>
                  <Avatar
                    src={testimonial.avatar}
                    alt={testimonial.author}
                    loading="lazy"
                  />
                  <AuthorDetails>
                    <h3>{testimonial.author}</h3>
                    <p>{testimonial.role}</p>
                  </AuthorDetails>
                </AuthorContainer>
              </ContentContainer>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}
